import LineTool from './LineTool';

/** Horizontal line tool */
class HorizontalLineTool extends LineTool {
	get shouldSnap() { return false; }

	_getDefaultParams() {
		return {
			id: 'horizontalLine',
			name: 'Horizontal Line',
			lockVertical: true,
			style: this.core.getStyle('tool.horizontalLine')
		};
	}
}

export default HorizontalLineTool;
